module.exports = __webpack_public_path__ + "static/automation-en-83f33cdf1cd3c8c356d4d46d229c6817.png";